'use client';

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';
import ThemeProvider from '@/components/ThemeProvider';

// DATA SOURCE
const allImages = [
  { id: 1, src: "https://images.unsplash.com/photo-1735202375769-b44ffd5b2776", alt: 'Hasil laser cutting pagar besi motif arabesque hitam', selected: true },
  { id: 2, src: "https://img.rocket.new/generatedImages/rocket_gen_img_127df5227-1778124777107.png", alt: 'Panel dekoratif laser cutting motif bunga stainless steel', selected: true },
  { id: 3, src: "https://img.rocket.new/generatedImages/rocket_gen_img_17de1ab00-1778124775554.png", alt: 'Cutting metal presisi tinggi dengan pola geometris', selected: true },
  { id: 5, src: "https://img.rocket.new/generatedImages/rocket_gen_img_101f4c012-1778124775673.png", alt: 'Hasil ukiran CNC router kayu MDF motif islami', selected: false },
  { id: 6, src: "https://images.unsplash.com/photo-1637267285101-7816ee8b6bd0", alt: 'Pagar laser cutting besi hitam motif daun', selected: false },
  { id: 7, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1b3e0f116-1766553791706.png", alt: 'Panel dinding dekoratif laser cutting aluminium', selected: false },
  { id: 8, src: "https://img.rocket.new/generatedImages/rocket_gen_img_14012e5ee-1774479427516.png", alt: 'Ornamen pintu laser cutting motif klasik', selected: true },
  { id: 9, src: "https://img.rocket.new/generatedImages/rocket_gen_img_130dc6b71-1772127313628.png", alt: 'Nomor rumah laser cutting stainless steel', selected: false },
  { id: 10, src: "https://img.rocket.new/generatedImages/rocket_gen_img_15201beb7-1778124776912.png", alt: 'Partisi ruangan laser cutting motif batik', selected: false },
  { id: 11, src: "https://img.rocket.new/generatedImages/rocket_gen_img_14ef9d823-1765201995978.png", alt: 'Cutting akrilik warna untuk display toko', selected: true },
  { id: 12, src: "https://images.unsplash.com/photo-1700965824180-ffebe7c13305", alt: 'Pagar besi laser cutting motif geometris modern', selected: false },
  { id: 13, src: "https://images.unsplash.com/photo-1676616756850-604906fee601", alt: 'Hasil laser cutting plat besi motif floral', selected: false },
  { id: 14, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d0dd5060-1778124777006.png", alt: 'Panel dekoratif CNC router kayu jati', selected: false },
  { id: 16, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d47b702a-1768628393381.png", alt: 'Cutting stainless steel untuk kebutuhan industri', selected: false },
  { id: 17, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee4c19eb-1773179374457.png", alt: 'Laser cutting kayu MDF untuk furniture dekoratif', selected: false },
  { id: 18, src: "https://images.unsplash.com/photo-1645762853626-1c6d872ce872", alt: 'Pagar laser cutting motif arabesque silver', selected: false },
  { id: 19, src: "https://images.unsplash.com/photo-1645323419330-8c95ad6a8edb", alt: 'Hasil laser cutting plat hitam motif bunga', selected: false },
  { id: 20, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1da11e310-1778124777096.png", alt: 'Panel CNC router kayu untuk backdrop foto', selected: false },
  { id: 21, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1c083654a-1778124777122.png", alt: 'Cutting besi motif islami untuk masjid', selected: false },
  { id: 22, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1946c7fc3-1772495915649.png", alt: 'Laser cutting akrilik untuk signage toko', selected: false },
  { id: 23, src: "https://images.unsplash.com/photo-1637267285101-7816ee8b6bd0", alt: 'Ornamen pagar laser cutting motif daun tropis', selected: false },
  { id: 24, src: "https://img.rocket.new/generatedImages/rocket_gen_img_17f8aeaa4-1768809713147.png", alt: 'Cutting plat besi untuk kebutuhan konstruksi', selected: false },
  { id: 25, src: "https://img.rocket.new/generatedImages/rocket_gen_img_17b8af25b-1778124775971.png", alt: 'Panel dekoratif laser cutting motif wayang', selected: false },
  { id: 26, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8cbeecc-1772171304591.png", alt: 'Laser cutting stainless motif geometris modern', selected: false },
  { id: 27, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1e7cfcb5e-1772205786614.png", alt: 'Hasil CNC router kayu untuk interior rumah', selected: false },
  { id: 28, src: "https://img.rocket.new/generatedImages/rocket_gen_img_19eaf1edc-1778124776679.png", alt: 'Cutting besi hitam untuk pagar minimalis modern', selected: false },
  { id: 29, src: '/assets/galeri/1.png', alt: '', selected: true },
  { id: 30, src: '/assets/galeri/2.png', alt: '', selected: false },
  { id: 31, src: '/assets/galeri/3.png', alt: '', selected: true },
  { id: 32, src: '/assets/galeri/4.png', alt: '', selected: false },
  { id: 33, src: '/assets/galeri/5.png', alt: '', selected: false },
  { id: 34, src: '/assets/galeri/6.png', alt: '', selected: false },
  { id: 35, src: '/assets/galeri/7.jpg', alt: '', selected: false },
  { id: 36, src: '/assets/galeri/8.jpg', alt: '', selected: false },
  { id: 37, src: '/assets/galeri/9.jpg', alt: '', selected: false },
  { id: 38, src: '/assets/galeri/10.jpg', alt: '', selected: false },
  { id: 39, src: '/assets/galeri/11.jpg', alt: '', selected: false },
  { id: 40, src: '/assets/galeri/12.jpg', alt: '', selected: false },
  { id: 41, src: '/assets/galeri/13.jpg', alt: '', selected: false },
  { id: 42, src: '/assets/galeri/14.jpg', alt: '', selected: false },
  { id: 43, src: '/assets/galeri/15.jpg', alt: '', selected: false },
  { id: 44, src: '/assets/galeri/16.jpg', alt: '', selected: false },
  { id: 45, src: '/assets/galeri/17.jpg', alt: '', selected: false },
  { id: 46, src: '/assets/galeri/18.jpg', alt: '', selected: false },
  { id: 47, src: '/assets/galeri/19.jpg', alt: '', selected: false },
  { id: 48, src: '/assets/galeri/20.jpg', alt: '', selected: false },
  { id: 49, src: '/assets/galeri/21.jpg', alt: '', selected: false },
  { id: 50, src: '/assets/galeri/22.jpg', alt: '', selected: false },
  { id: 51, src: '/assets/galeri/23.jpg', alt: '', selected: false },
  { id: 52, src: '/assets/galeri/24.jpg', alt: '', selected: false },
  { id: 53, src: '/assets/galeri/25.png', alt: '', selected: false },
  { id: 54, src: '/assets/galeri/26.jpeg', alt: '', selected: false },
  { id: 55, src: '/assets/galeri/27.jpeg', alt: '', selected: false },
  { id: 56, src: '/assets/galeri/28.jpeg', alt: '', selected: false },
  { id: 57, src: '/assets/galeri/29.jpeg', alt: '', selected: false },
  { id: 58, src: '/assets/galeri/30.jpeg', alt: '', selected: false },
  { id: 59, src: '/assets/galeri/31.jpeg', alt: '', selected: false },
  { id: 60, src: '/assets/galeri/32.jpeg', alt: '', selected: false },
  { id: 61, src: '/assets/galeri/33.jpeg', alt: '', selected: false },
  { id: 62, src: '/assets/galeri/34.jpeg', alt: '', selected: false },
  { id: 63, src: '/assets/galeri/35.jpeg', alt: '', selected: false },
  { id: 64, src: '/assets/galeri/36.jpeg', alt: '', selected: false },
];

// ANIMATION VARIANTS
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1, 
    transition: { staggerChildren: 0.05 } 
  }
};

const itemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { 
    opacity: 1, 
    scale: 1, 
    transition: { duration: 0.4, ease: "easeOut" } 
  },
  exit: { 
    opacity: 0, 
    scale: 0.9, 
    transition: { duration: 0.2 } 
  }
};

export default function GaleriPage() {
  const [activeTab, setActiveTab] = useState<'selected' | 'all'>('all');
  const [selectedImg, setSelectedImg] = useState<string | null>(null);

  // Filter logic
  const displayedImages = activeTab === 'selected' 
    ? allImages.filter((img) => img.selected) 
    : allImages;

  const selectedCount = allImages.filter(img => img.selected).length;

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        
        <main>
          {/* Hero Section */}
          <section className="bg-[#1E1B4B] dark:bg-[#0B2E26] py-14 px-4 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-3xl md:text-4xl font-extrabold text-white mb-3">
              Galeri & Workshop
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-white/70 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              Lihat hasil karya dan proses produksi kami — dari laser cutting presisi hingga CNC Router berkualitas tinggi.
            </motion.p>
          </section>

          {/* Filter Section */}
          <section className="py-10 px-4">
            <div className="flex justify-center gap-4 mb-10">
              <button
                onClick={() => setActiveTab('selected')}
                className={`px-6 py-2.5 rounded-full text-sm font-bold border transition-all duration-300 shadow-sm ${
                  activeTab === 'selected' 
                    ? 'bg-[#1E1B4B] text-white border-[#1E1B4B]' 
                    : 'bg-secondary/50 text-foreground border-transparent hover:border-border'
                }`}>
                Pilihan Utama 
              </button>
              <button
                onClick={() => setActiveTab('all')}
                className={`px-6 py-2.5 rounded-full text-sm font-bold border transition-all duration-300 shadow-sm ${
                  activeTab === 'all' 
                    ? 'bg-[#1E1B4B] text-white border-[#1E1B4B]' 
                    : 'bg-secondary/50 text-foreground border-transparent hover:border-border'
                }`}>
                Semua Karya
              </button>
            </div>

            {/* Gallery Grid */}
            <div className="max-w-6xl mx-auto">
              <motion.div
                layout
                className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3"
                variants={containerVariants}
                initial="hidden"
                animate="visible">
                
                <AnimatePresence mode="popLayout">
                  {displayedImages.map((img) => (
                    <motion.div
                      layout
                      key={img.id}
                      variants={itemVariants}
                      initial="hidden"
                      animate="visible"
                      exit="exit"
                      onClick={() => setSelectedImg(img.src)}
                      className="group relative aspect-square rounded-xl overflow-hidden bg-muted cursor-pointer ring-1 ring-border hover:ring-accent transition-all duration-300 shadow-sm">
                      <img
                        src={img.src}
                        alt={img.alt}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        loading="lazy"
                      />
                      {/* Hover Overlay */}
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                         <p className="text-white text-[10px] leading-tight line-clamp-2 bg-black/20 backdrop-blur-sm p-1 rounded">
                           {img.alt}
                         </p>
                      </div>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </motion.div>
            </div>
          </section>
        </main>

        {/* Fullscreen Lightbox Modal */}
        <AnimatePresence>
          {selectedImg && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedImg(null)}
              className="fixed inset-0 z-[999] flex items-center justify-center bg-black/95 p-4 backdrop-blur-md cursor-zoom-out">
              
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                className="relative max-w-5xl w-full flex flex-col items-center">
                
                <img 
                  src={selectedImg} 
                  alt="Full preview" 
                  className="rounded-lg max-h-[85vh] object-contain shadow-2xl border border-white/10" 
                />

                <button 
                  className="mt-6 flex items-center gap-2 text-white/80 hover:text-white bg-white/10 px-6 py-2 rounded-full border border-white/10 transition-all font-medium"
                  onClick={() => setSelectedImg(null)}>
                  Tutup [X]
                </button>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </ThemeProvider>
  );
}